// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timezone-picker-panel{display:flex;flex-wrap:wrap}.timezone-picker-buttons{display:flex}.timezone-picker-buttons>span{background-color:#333;border-color:#333;border-radius:5px;color:#fff;cursor:pointer;margin-left:10px;padding:2px 10px}.timezone-picker-buttons>span:hover{background-color:#1a1a1a;border-color:#1a1a1a}.timezone-picker-text{margin-left:10px}.timezone-picker-text p{margin:0}", ""]);
// Exports
module.exports = exports;
